import { render, staticRenderFns } from "./CreateNewPiecesModal.vue?vue&type=template&id=128cef7e&scoped=true&lang=pug"
import script from "./CreateNewPiecesModal.vue?vue&type=script&lang=js"
export * from "./CreateNewPiecesModal.vue?vue&type=script&lang=js"
import style0 from "./CreateNewPiecesModal.vue?vue&type=style&index=0&id=128cef7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128cef7e",
  null
  
)

export default component.exports